import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

const ONE_WAY_SEGMENTS = 1
const ROUND_TRIP_SEGMENTS = 2

const isOneWayOrRoundTrip = (directions: DifficultRoute[]) =>
  directions.length === ONE_WAY_SEGMENTS

const isMirroredRoundTrip = (directions: DifficultRoute[]) => {
  if (directions.length !== ROUND_TRIP_SEGMENTS) return false

  const [forward, backward] = directions

  const departure = forward.from?.cityIataCode
  const arrival = forward.to?.cityIataCode

  if (!departure || !arrival) return false

  return (
    departure === backward.to?.cityIataCode &&
    arrival === backward.from?.cityIataCode
  )
}

export const isRegularRoute = (directions?: DifficultRoute[]) => {
  if (!directions?.length) return false

  return isOneWayOrRoundTrip(directions) || isMirroredRoundTrip(directions)
}
